import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import VendaItemForm from './VendaItemForm';
import NotaFiscalEmissaoComplForm from './NotaFiscalEmissaoComplForm';
import TituloParcelaForm from './TituloParcelaForm';
import ModalPadraoForm from './ModalPadraoForm';
import SpinnerForm from './SpinnerForm';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class VendaForm extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_desc: 0,
      ven_vlr_desc_venda: 0,
      ven_vlr_total: 0,
      ven_emitir_nfe: false,
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_tipo_doc: { key: '0' },
      ven_cond_pagto: { key: '0' },
    },

    registroNfe: {},

    modalProdutoVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,
    modalEmissaoNFeVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "dados",

    listaProdutos: [],
    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        ven_pessoa: this.props.registroSelecionado.dados.ven_pessoa,
        ven_usuario: this.props.registroSelecionado.dados.ven_usuario,
        ven_tipo_doc: this.props.registroSelecionado.dados.ven_tipo_doc,
        ven_cond_pagto: this.props.registroSelecionado.dados.ven_cond_pagto,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        caixaFechado,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.props.registroSelecionado.dados.ven_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }




  onOK = () => {
    if ((!this.state.registro.ven_dt_venda) || (!moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.ven_pessoa) || (this.state.registro.ven_pessoa.key === '0') || (this.state.registro.ven_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.ven_usuario) || (this.state.registro.ven_usuario.key === '0') || (this.state.registro.ven_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na Venda' });
      return;
    }

    if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in this.state.listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total da Venda não Confere com o Valor Total das parcelas' });
        return;
      }
    }


    if (this.state.ven_emitir_nfe) {
      Modal.confirm({
        title: 'Confirmação de Emissão',
        content: `Deseja Emitir NFe desta venda?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => { this.onAbrirModalEmissaoNFeClick() }
      })
    } else {
      this.onSalvar();
    }
  }


  onSalvar = (reg) => {

    // console.log('VendaForm.onSalvar', reg)

    const registro = {
      ven_idf: this.state.registro.ven_idf,
      ven_dt_venda: moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ven_numero: this.state.registro.ven_numero ? this.state.registro.ven_numero : '0',
      ven_pessoa: this.state.ven_pessoa.key,
      pes_nome: this.state.ven_pessoa.label,
      ven_usuario: this.state.ven_usuario.key,
      ven_tipo_doc: this.state.registro.ven_tipo_doc.key ? this.state.registro.ven_tipo_doc.key : 0,
      ven_cond_pagto: this.state.registro.ven_cond_pagto.key ? this.state.registro.ven_cond_pagto.key : 0,
      ven_vlr_itens: this.state.registro.ven_vlr_itens,
      ven_vlr_desc: this.state.registro.ven_vlr_desc,
      ven_vlr_desc_venda: this.state.registro.ven_vlr_desc_venda,
      ven_vlr_acres: this.state.registro.ven_vlr_acres,
      ven_vlr_total: this.state.registro.ven_vlr_total,
      ven_obs: this.state.registro.ven_obs,
      ven_emitir_nfe: this.state.registro.ven_emitir_nfe ? this.state.registro.ven_emitir_nfe : '0',

      listaProdutos: this.state.listaProdutos,
      listaParcelas: this.state.listaParcelas,

      registroNfe: reg,
    };


    // console.log('onSalvar', registro)

    this.props.onSalvarClick(registro);
  };



  // ----------------------------------------------------------------
  // EMISSÃO NFE
  // ----------------------------------------------------------------

  onAbrirModalEmissaoNFeClick = () => {
    // console.log('onAbrirModalEmissaoNFeClick', this.state.registro);

    if (this.state.registro.nf_idf) {

      this.setState({ carregando: true });
      axios.get(`/notas_fiscais/show/${this.state.registro.nf_idf}`)
        .then(response => {
          const { data } = response;

          data.dados.nf_tipo = 'Venda';
          data.dados.nf_dt_inclusao = moment(data.dados.nf_dt_inclusao, 'YYYY-MM-DD').format('DD/MM/YYYY');
          data.dados.nf_dt_emissao = moment(data.dados.nf_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');

          data.dados.nf_destinatario = {
            key: String(this.state.registro.ven_pessoa.key),
            label: this.state.registro.ven_pessoa.label,
          };

          data.dados.nf_tipo_mov_nf = { key: String(data.dados.nf_tipo_mov_nf), label: '', };
          data.dados.nf_emitente = { key: String(data.dados.nf_emitente), label: '', };
          data.dados.nf_modelo = { key: String(data.dados.nf_modelo), label: '', };
          data.dados.nf_nat_oper = { key: String(data.dados.nf_nat_oper), label: '', };
          data.dados.nf_forma_pagamento = { key: String(data.dados.nf_forma_pagamento), label: '', };
          data.dados.nf_finalidade_emissao = { key: String(data.dados.nf_finalidade_emissao), label: '', };
          data.dados.nf_consumidor_final = { key: String(data.dados.nf_consumidor_final), label: '', };
          data.dados.nf_tipo_documento = { key: String(data.dados.nf_tipo_documento), label: '', };
          data.dados.nf_tipo_atendimento = { key: String(data.dados.nf_tipo_atendimento), label: '', };
          data.dados.nff_tipo = { key: String(data.dados.nff_tipo), label: '', };
          data.dados.nff_idf_transportadora = { key: data.dados.nff_idf_transportadora ? String(data.dados.nff_idf_transportadora) : '0', label: '', };

          data.dados.nf_cond_pagto = {
            key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tit_cond_pagto) ? String(data.listaParcelas[0].tit_cond_pagto) : '',
            label: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_descricao) ? String(data.listaParcelas[0].cp_descricao) : '',
            qtdeParc: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_qtde_parc) ? String(data.listaParcelas[0].cp_qtde_parc) : '',
            parcAVista: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_parc_avista) ? String(data.listaParcelas[0].cp_parc_avista) : '',
          }

          data.dados.nf_tipo_doc = {
            key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
            label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
          }

          data.dados.visualizando = false;

          this.setState({
            modalEmissaoNFeVisible: true,
            registroNfe: {
              registro: data,
              registroVenda: this.state.registro,
              listaProdutosNF: data.listaProdutos,
              listaProdutosVenda: this.state.listaProdutos
            },
            carregando: false,
          })
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            carregando: false,
          })
        })
    } else {
      this.setState({
        modalEmissaoNFeVisible: true,
        registroNfe: {
          registro: {
            dados: {
              nf_destinatario: {
                key: String(this.state.registro.ven_pessoa.key),
                label: this.state.registro.ven_pessoa.label,
              },
              nf_idf: 0,
              nf_tipo: 'Venda',
              nf_numero: '0',
              nf_serie: '0',
              situacao_nota: 'Nova NFe',
              nf_dt_inclusao: moment().format('DD/MM/YYYY'),
              nf_dt_emissao: moment().format('DD/MM/YYYY'),
              nf_forma_pagamento: { key: '2', label: '', },
              nf_finalidade_emissao: { key: '1', label: '', },
              nf_consumidor_final: { key: '1', label: '', },
              nf_tipo_documento: { key: '1', label: '', },
              nf_tipo_atendimento: { key: '1', label: '', },
              nff_tipo: { key: '9', label: '', },

              nff_idf_transportadora: { key: '0', label: '', },
              nff_especie: 0,
              nff_marca: 0,
              nff_num_volumes: 0,
              nff_peso_bruto: 0,
              nff_peso_liquido: 0,
              nff_qtde_vol: 0,

            }
          },
          registroVenda: this.state.registro,
          listaProdutosNF: [],
          listaProdutosVenda: this.state.listaProdutos
        },
        carregando: false,
      })
    }
  }

  onFecharModalEmissaoNFeClick = () => {
    this.setState({
      modalEmissaoNFeVisible: false,
    });
  }

  onSalvarEmissaoNfeClick = (registroNfe) => {
    this.setState({
      modalEmissaoNFeVisible: false,
    },
      this.onSalvar(registroNfe)
    );
  }

  // ----------------------------------------------------------------




  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;
    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].mi_qtde) * parseFloat(listaProdutos[x].mi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(listaProdutos[x].mi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(listaProdutos[x].mi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.ven_qtde_itens = qtdeItens;
    registro.ven_vlr_itens = vlrItens;
    registro.ven_vlr_desc = vlrDesc;
    registro.ven_vlr_acres = vlrAcres;
    registro.ven_vlr_total = vlrTotal - registro.ven_vlr_desc_venda;

    this.setState({
      registro,
    });
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangeDesconto = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;

    // console.log('onChangeDesconto: ', registro)
    // console.log('onChangeDesconto: ', value)
    // console.log('onChangeDesconto: ', registro.ven_vlr_itens - (registro.ven_vlr_desc + value))

    registro[id] = value;
    this.setState({
      [id]: value,
      ven_vlr_total: registro.ven_vlr_itens - (registro.ven_vlr_desc + value)
    });

    this.state.registro.ven_vlr_total = registro.ven_vlr_itens - (registro.ven_vlr_desc + value);
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ven_pessoa'] = event.ven_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['ven_usuario'] = event.ven_usuario;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['ven_dt_venda'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ ven_dt_venda: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }





  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        tipoTela: 'VEN',
        registro: {
          mi_seq: 0,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          prod_ncm: '',
          med_descricao: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    const itemOriginal = reg.mi_item && typeof reg.mi_item === 'object' ? reg.mi_item : {};
    const produtoId = reg.prod_idf || itemOriginal.pest_item || reg.mi_item;
    const tamanho = reg.mi_item_tamanho != null ? reg.mi_item_tamanho : (itemOriginal.pest_tamanho || 0);
    const cor = reg.mi_item_cor != null ? reg.mi_item_cor : (itemOriginal.pest_cor || 0);
    const descricao = reg.prod_descricao || itemOriginal.descr || itemOriginal.label || '';
    const variacao = reg.prod_grade ? [reg.ptam_descricao, reg.pcor_descricao].filter(Boolean).join(' - ') : '';
    const descricaoProduto = descricao + (variacao ? ' - ' + variacao : '')
      + (reg.prod_codigo != null ? ' [' + reg.prod_codigo + ']' : '')
      + (reg.prod_cod_barras ? ' [' + reg.prod_cod_barras + ']' : '');
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        tipoTela: 'VEN',
        registro: {
          mi_item: {
            key: String(produtoId) + '_' + String(tamanho) + '_' + String(cor),
            label: descricaoProduto,
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: produtoId,
            pest_tamanho: tamanho,
            pest_cor: cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_ncm: reg.prod_ncm,
          prod_cod_barras: reg.prod_cod_barras,
          med_descricao: reg.med_descricao,
          mi_qtde: reg.mi_qtde,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_acres: reg.mi_vlr_acres || 0,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,
          tipoItem: 'P',
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }




  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };




  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.ven_tipo_doc) || (this.state.registro.ven_tipo_doc.key === '0') || (this.state.registro.ven_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.ven_cond_pagto) || (this.state.registro.ven_cond_pagto.key === '0') || (this.state.registro.ven_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.ven_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.ven_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.ven_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.ven_vlr_total) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.ven_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.ven_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.ven_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.ven_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['ven_tipo_doc'] = event.ven_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['ven_cond_pagto'] = event.ven_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------





  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { carregandoForm, usuario, listaProdutos, listaParcelas, produtoSelecionado, registroNfe,
      vlrDifParc, vlrTotalParc, caixaFechado, modalListaVisible, modalParcelaVisible, modalProdutoVisible, modalEmissaoNFeVisible } = this.state;

    const { ven_idf, ven_numero, ven_dt_venda, ven_pessoa, ven_obs, ven_cond_pagto, ven_tipo_doc,
      ven_qtde_itens, ven_vlr_itens, ven_vlr_desc, ven_vlr_desc_venda, ven_vlr_total, ven_usuario, ven_emitir_nfe } = this.state.registro;

    // console.log('VendaForm.this.state: ', this.state);

    return (
      <Modal
        title={ven_idf ? (this.state.visualizando ? "Venda" : "Edição de Venda") : "Inclusão de Venda"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'clientes'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <VendaItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />

        <NotaFiscalEmissaoComplForm
          visivel={modalEmissaoNFeVisible}
          onSalvarEmissaoNfeClick={this.onSalvarEmissaoNfeClick}
          onFecharModalEmissaoNFeClick={this.onFecharModalEmissaoNFeClick}
          registroNfe={registroNfe}
          listaProdutos={listaProdutos}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={ven_vlr_total}
          condPagto={ven_cond_pagto}
        />

        <SpinnerForm visivel={carregando} texto={'Transmitindo Nota. Aguarde...'} />

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados do Pedido
                      </span>
                    </div>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="ven_numero"
                        ref="ven_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={ven_numero}
                        readOnly
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 4 }} className="camposEspacoDireita">
                      <span>Data Pedido *</span>
                      <DatePicker
                        onChange={this.onDateChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(ven_dt_venda, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={11}>
                      <PessoaFrame
                        label="Cliente *"
                        id="ven_pessoa"
                        value={ven_pessoa}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        disabled={caixaFechado}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <UsuarioFrame
                        label="Vendedor *"
                        id="ven_usuario"
                        value={ven_usuario}
                        width={"100%"}
                        vendedor={1}
                        onChange={this.onChangeVendedor}
                        descricaoPrimeiroItem="Selecione um Vendedor"
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Quantidade Pordutos</span>
                      <InputForm
                        type="number"
                        id="ven_qtde_itens"
                        ref="ven_qtde_itens"
                        value={ven_qtde_itens}
                        decimalScale={0}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Valor Itens</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_itens"
                        ref="ven_vlr_itens"
                        value={ven_vlr_itens}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Desconto Itens</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_desc"
                        ref="ven_vlr_desc"
                        value={ven_vlr_desc}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Desconto Venda</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_desc_venda"
                        ref="ven_vlr_desc_venda"
                        value={ven_vlr_desc_venda}
                        onChange={this.onChangeDesconto}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Valor Total</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_total"
                        ref="ven_vlr_total"
                        value={ven_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    {usuario && (usuario.emissorNFe || usuario.emissorNFCe) && this.state.registro.nf_status !== 1 ? (
                      <Col xs={24} sm={6}>
                        <InputForm
                          type="checkbox"
                          id="ven_emitir_nfe"
                          ref="ven_emitir_nfe"
                          onChange={this.onChange}
                          value={ven_emitir_nfe ? true : false}
                        >
                          Emitir NFe
                        </InputForm>
                      </Col>
                    ) : (
                      <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                        <span>NFe Emitida</span>
                        <InputForm
                          id="nf_numero"
                          ref="nf_numero"
                          maxLength={9}
                          onChange={this.onChange}
                          value={this.state.registro.nf_numero}
                          readOnly
                        />
                      </Col>
                    )}

                    <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <span>OBS</span>
                      <InputForm
                        id="ven_obs"
                        ref="ven_obs"
                        value={ven_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Produtos" key="produtos">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                    > Novo Produto
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  scroll={{ y: 245 }}
                  dataSource={listaProdutos}
                  pagination={false}
                  rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizar || caixaFechado || (this.state.registro.nf_idf && ((this.state.registro.nf_status === 1) || (this.state.registro.nf_status === 4) || (this.state.registro.nf_status === 5))) ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>



            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 350 }}>

                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="ven_tipo_doc"
                          value={ven_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="ven_cond_pagto"
                          value={ven_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(ven_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      scroll={{ y: 245 }}
                      dataSource={listaParcelas}
                      pagination={false}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || caixaFechado || (this.state.registro.nf_idf && ((this.state.registro.nf_status === 1) || (this.state.registro.nf_status === 4) || (this.state.registro.nf_status === 5))) ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar Venda
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendaForm.js